<template>
  <footer class="app-footer">
    <a href="http://enchatment.com">Enchatment</a> &copy; 2017 - {{currentYear}}
    <span class="float-right">Powered by <a href="http://chatinfinite.com">Chat Infinite</a></span>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      currentYear: '',
    }
  },
  mounted: function() {
    this.currentYear = new Date().getFullYear()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?0e8d60c0